import { render, staticRenderFns } from "./ViewTextModal.vue?vue&type=template&id=9695a644&scoped=true&"
import script from "./ViewTextModal.vue?vue&type=script&lang=js&"
export * from "./ViewTextModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewTextModal.vue?vue&type=style&index=0&id=9695a644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9695a644",
  null
  
)

export default component.exports